import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";

// Forma que devuelve GET /api/v1/acceso/paneles (ver acceso_routes.py).
export interface PanelAcceso {
  id: string;
  agencia: string;
  tipo: "Peatonal" | "Vehicular" | "Panel";
  nombre: string;
  ip: string;
  modelo: string;
  firmware: string;
  // Medido al momento, sin contraseña: "up" = el panel contesta.
  state: "up" | "down";
  ms: number | null;
  actionable: boolean;
  reason: string;
}

interface PanelesAcceso {
  items: PanelAcceso[];
}

interface ReinicioPanel {
  ok: boolean;
  id: string;
  ip: string;
  nombre: string;
  detail: string;
}

const REFETCH_MS = 60_000;

export function usePanelesAcceso() {
  return useQuery({
    queryKey: ["acceso-paneles"],
    queryFn: ({ signal }) => api<PanelesAcceso>("/api/v1/acceso/paneles", { signal }),
    refetchInterval: REFETCH_MS,
    placeholderData: (prev) => prev,
  });
}

export function useReiniciarPanel() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      api<ReinicioPanel>(`/api/v1/acceso/paneles/${encodeURIComponent(id)}/reiniciar`, {
        method: "POST",
      }),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: ["acceso-paneles"] });
      void qc.invalidateQueries({ queryKey: ["reboot-historial"] });
    },
  });
}
